import { gql, useMutation } from '@apollo/client';

const PROCESS_PORTFOLIO_BUYS = gql`
  mutation processPortfolioBuys($data: PortfolioBuysInput!) {
    processPortfolioBuys(data: $data)
  }
`;

export const useProcessPortfolioBuys = () => {
  return useMutation(PROCESS_PORTFOLIO_BUYS);
};
